/**
 * VARIATION_TIMESHEET_TAB.JSX - Variation Timesheet Tab Component
 * 
 * SUMMARY:
 * Presentational component for the timesheet/allocation tab.
 * Displays allocated users table and assignment controls.
 * 
 * PROPS:
 * @param {Array} allocates - List of allocations
 * @param {Function} mapUserName - Map user ID to name
 * @param {Function} handleEditTimesheet - Edit timesheet handler
 * @param {Function} deleteDialogHandler - Delete dialog handler
 * @param {Function} handleAllocationDialog - Open allocation dialog
 * @param {boolean} editMode - Whether in edit mode
 * @param {string} optionId - Variation ID
 * 
 * @returns {JSX.Element} Timesheet tab content
 */

import React from 'react';
import Button from 'react-bootstrap/Button';
import Table from 'react-bootstrap/Table';
import { numberFormat } from "../../../../util/currency-formatter";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

export default function VariationTimesheetTab({
    allocates,
    mapUserName,
    handleEditTimesheet,
    deleteDialogHandler,
    handleAllocationDialog,
    editMode,
    optionId
}) {
    return (
        <>
            <div className="list-title">
                <h6>Allocated Users</h6>
                <div className="table-responsive">
                    <Table bordered className="table-create table-material tbl-fixed">
                        <thead>
                            <tr>
                                <th>Assigned User</th>
                                <th>Date</th>
                                <th>Start Time</th>
                                <th>End Time</th>
                                <th>Normal Hours</th>
                                <th>Overtime</th>
                                <th>Status</th>
                                <th className="text-center">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {allocates.map((e, i) => {
                                return (
                                    <tr key={i}>
                                        <td>{mapUserName(e.userId)}</td>
                                        <td>{e.date}</td>
                                        <td>{e.starttime}</td>
                                        <td>{e.endtime}</td>
                                        <td>{numberFormat(e.normalHours, true)}</td>
                                        <td>{numberFormat(e.overtimeHours, true)}</td>
                                        <td className="status">{e.status}</td>
                                        <td>
                                            {editMode && (
                                                <div className="d-flex justify-content-center">
                                                    <div className="action-edit me-2">
                                                        <EditIcon onClick={() => handleEditTimesheet(e.id)} />
                                                    </div>
                                                    <div className="action-edit me-2">
                                                        <DeleteIcon onClick={() => deleteDialogHandler(e)} />
                                                    </div>
                                                </div>
                                            )}
                                        </td>
                                    </tr>
                                );
                            })}
                            {allocates.length < 1 && (
                                <tr>
                                    <td className="text-center" colSpan={8}>No Data</td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                </div>
            </div>

            {optionId && editMode && (
                <div className="col-12 mt-2 d-flex btn-res">
                    <Button
                        type="submit"
                        className="ms-auto primarybtn"
                        onClick={handleAllocationDialog}
                    >
                        + Assign User
                    </Button>
                </div>
            )}
        </>
    );
}

